var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M1 16.4L30 2L59 16.4V43.4L30 56L1 43.4V16.4Z",
    stroke: "url(#paint0_linear_1266_31041)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_31041",
    x1: 57.4395,
    y1: 55.9999,
    x2: 2.82113,
    y2: 56.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/level-6.1f81cf1e166547ae3e195a7382cf57c0.svg";
export { ForwardRef as ReactComponent };